import { render, staticRenderFns } from "./monitorStyle.vue?vue&type=template&id=004dc724&scoped=true"
import script from "./monitorStyle.vue?vue&type=script&lang=js"
export * from "./monitorStyle.vue?vue&type=script&lang=js"
import style0 from "./monitorStyle.vue?vue&type=style&index=0&id=004dc724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004dc724",
  null
  
)

export default component.exports